import { create } from 'zustand'

interface ModalArchivePropertyState {
  modalArchiveProperty: {
    isOpen: boolean
    propertiesIds: string[]
    title: string
    where: 'label' | 'difusion'
    onSuccess?: () => void
  }
  setModalArchiveProperty: (modalArchiveProperty: {
    isOpen: boolean
    propertiesIds: string[]
    title: string
    where: 'label' | 'difusion'
    onSuccess?: () => void
  }) => void
  reset: () => void
}

const initialState = {
  modalArchiveProperty: {
    isOpen: false,
    propertiesIds: [],
    title: '',
    where: 'label' as 'label' | 'difusion'
  }
}

export const useModalArchivePropertyStore = create<ModalArchivePropertyState>()(
  (set) => ({
    ...initialState,
    setModalArchiveProperty: (modalArchiveProperty) =>
      set({ modalArchiveProperty }),
    reset: () =>
      set({
        modalArchiveProperty: initialState.modalArchiveProperty
      })
  })
)
